import {createAction} from '@reduxjs/toolkit'

export const updateKudos = createAction('kudos/save', (data) => ({
  payload: data
}))

export const clearKudos = createAction('kudos/clear')
